export const PAGE_LAYOUT = {
  outer: 'max-w-7xl mx-auto px-6 py-8',
  section: 'space-y-6',
};

export const HEADING = {
  page: 'font-display text-2xl font-bold text-gray-900 tracking-tight',
  section: 'font-display text-lg font-semibold text-gray-900',
  card: 'font-display text-base font-semibold text-gray-900',
};

export const STATUS = {
  pending:             { bg: 'bg-amber-100',   text: 'text-amber-700',   dot: 'bg-amber-400' },
  pending_ticketing:   { bg: 'bg-amber-100',   text: 'text-amber-700',   dot: 'bg-amber-400' },
  draft:               { bg: 'bg-amber-100',   text: 'text-amber-700',   dot: 'bg-amber-400' },
  enquiry:             { bg: 'bg-amber-100',   text: 'text-amber-700',   dot: 'bg-amber-400' },
  active:              { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  completed:           { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  ticketed:            { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  paid:                { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  approved:            { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  accepted:            { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  converted:           { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  offers_found:        { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  booked:              { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  checked_in:          { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  checked_out:         { bg: 'bg-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  cancelled:           { bg: 'bg-red-100',     text: 'text-red-700',     dot: 'bg-red-400' },
  overdue:             { bg: 'bg-red-100',     text: 'text-red-700',     dot: 'bg-red-400' },
  rejected:            { bg: 'bg-red-100',     text: 'text-red-700',     dot: 'bg-red-400' },
  refunded:            { bg: 'bg-sky-100',     text: 'text-sky-700',     dot: 'bg-sky-400' },
  searching:           { bg: 'bg-blue-100',    text: 'text-blue-700',    dot: 'bg-blue-400' },
  sent:                { bg: 'bg-blue-100',    text: 'text-blue-700',    dot: 'bg-blue-400' },
  contacted:           { bg: 'bg-blue-100',    text: 'text-blue-700',    dot: 'bg-blue-400' },
  in_review:           { bg: 'bg-blue-100',    text: 'text-blue-700',    dot: 'bg-blue-400' },
  quoted:              { bg: 'bg-indigo-100',  text: 'text-indigo-700',  dot: 'bg-indigo-400' },
  reopened:            { bg: 'bg-indigo-100',  text: 'text-indigo-700',  dot: 'bg-indigo-400' },
  in_progress:         { bg: 'bg-indigo-100',  text: 'text-indigo-700',  dot: 'bg-indigo-400' },
  partially_cancelled: { bg: 'bg-orange-100',  text: 'text-orange-700',  dot: 'bg-orange-400' },
  closed:              { bg: 'bg-gray-100',    text: 'text-gray-600',    dot: 'bg-gray-400' },
  void:                { bg: 'bg-gray-100',    text: 'text-gray-600',    dot: 'bg-gray-400' },
};

export const STATUS_DEFAULT = { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' };
